export * from "./MdmCardDemoPage";
